import { render, staticRenderFns } from "./TextEdit.vue?vue&type=template&id=9f144bac&"
import script from "./TextEdit.vue?vue&type=script&lang=js&"
export * from "./TextEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports